Librarian.UserSettings = new Class({
    Extends: Librarian.Window,
    Binds: ["onSave", "onRestoreDefaults", "onCancel"],

    options: {
        id: "userSettings",
        title: "Settings",
        width: 500,
        height: 500,
        defaultTab: "menu"
    },

    selected: "menu",

    initialize: function (options) {
        this.setOptions(options);
        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/usersettings.html";

        this.parent(this.options);
    },

    onWindowLoaded: function () {
        this.parent();
        this.setupElements();

        var itemEl = this.getElement("cancelButton");
        if (itemEl)
            itemEl.addOnClick(this.onCancel);

        itemEl = this.getElement("saveButton");
        if (itemEl)
            itemEl.addOnClick(this.onSave);

        itemEl = this.getElement("restoreButton");
        if (itemEl)
            itemEl.addOnClick(this.onRestoreDefaults);

        this.loadMenuBarSettings();
    },

    loadMenuBarSettings: function () {
        var tabs = Array.clone(Librarian.tabs);
        var customTabs = Librarian.customUserSettings ? (Librarian.customUserSettings.menu || {}) : {};

        // Show GoToMeeting button
        if (Librarian.features.gotomeeting.load) {
            tabs.push("GoToMeeting");
        }

        // Show WebEx button
        if (Librarian.features.webex.load) {
            tabs.push("WebEx");
        }

        // Show ScreenLeap Button
        if (Librarian.features.screenLeap.load) {
            tabs.push("Share Screen");
        }

        // Show Workflow Button
        if (Librarian.features.workflow.load) {
            tabs.push("Workflow");
        }

        var menuEl = this.getElement("userSettingsMenu");

        Array.each(tabs, function (tab) {
            if (tab.static) {
                return;
            }

            var tabName, tabId;
            if (typeOf(tab) === "string") {
                tabName = tab;
                tabId = tabName.replace(/[^a-z]/gi, '').toLowerCase();
            } else {
                tabName = tab.label;
                tabId = tab.id || tabName.replace(/[^a-z]/gi, '').toLowerCase();
            }

            var wrapperEl = new Element('div');
            var checkBoxEl = new Element("input", {
                type: "checkbox",
                "checked": customTabs[tabId] !== false,
                name: tabId,
                disabled: tabId === "home" || tab.static ? "disabled" : ""
            });
            var labelEl = new Element("label", {
                text: tabName,
                "class": "spacerLeftMd"
            });

            checkBoxEl.inject(wrapperEl);
            labelEl.inject(wrapperEl);
            wrapperEl.inject(menuEl);
        });
    },

    onSave: function () {
        var settings = {};
        var menuEl = this.getElement("userSettingsMenu");

        switch (this.selected) {
            case "menu":
                menuEl.getElements("input").each(function (inputEl) {
                    var name = inputEl.getProperty("name");
                    var value = Librarian.Utils.getElementValue(inputEl);

                    settings[name] = value;
                });
                Librarian.customUserSettings.menu = settings;
                Librarian.UserSettings.setCustomUserSettings(Librarian.customUserSettings);
                break;
        }

        this.close();
        location.reload();
    },

    onRestoreDefaults: function () {
        switch (this.selected) {
            case "menu":
                Librarian.customUserSettings.menu = {};
                Librarian.UserSettings.setCustomUserSettings(Librarian.customUserSettings);
                break;
        }

        this.close();
        location.reload();
    },

    onCancel: function () {
        this.close();
    }
})
    .extend({
        defaultSettings: Librarian.customUserSettings.defaults || {},

        getCustomUserSettings: function () {
            var customSettings = {};

            var key = "userSettings_" + Librarian.libId + "_" + Librarian.userInfo.UserId;
            if (typeof (Storage) !== "undefined") {
                if (localStorage[key]) {
                    customSettings = JSON.parse(localStorage[key]);
                }
            }

            return Object.merge({}, Librarian.UserSettings.defaultSettings, customSettings);
        },
        setCustomUserSettings: function (settings) {
            var key = "userSettings_" + Librarian.libId + "_" + Librarian.userInfo.UserId;
            if (typeof (Storage) !== "undefined" && typeof (settings) !== "undefined") {
                localStorage[key] = JSON.stringify(settings);
            }
        }
    })